export function mapAuthError(code: string | null | undefined): string {
  if (!code) return '';
  switch (code) {
    case 'INVALID_STATE':
      return 'Sign-in link expired. Please try again.';
    case 'SIGNIN_ERROR':
      return 'Invalid email or password.';
    default:
      return 'Sign-in failed. Please try again.';
  }
}
